import type { EventRoute } from '@/shared/infrastructure/events/eventRouter';
import { subscriptionKeys } from './queryKeys';

export function registerSubscriptionEvents(
  register: (eventType: string, route: EventRoute) => void,
): void {
  // No invalidate: useBalance patches the cache directly from the event payload
  // (setQueryData) — a refetch here would defeat that and POST once per per-block
  // settle during generation. Keep the type registered (empty keys) so the SSE
  // listener still attaches.
  register('subscription.balance.updated', {
    getQueryKeys: () => [],
  });

  // tokens.insufficient is an ephemeral event consumed by useEventSourceEvent
  // on the client — no query invalidation needed, so return empty keys.
  register('tokens.insufficient', {
    getQueryKeys: () => [],
  });
}
